module.exports = __webpack_public_path__ + "static/media/SM-ST1-TRIAL-if-wrong.77ef50a8.mp3";